import { Box, Center, Spinner } from "@biblioteksentralen/react";
import { useSearchContext } from "./SearchContext";
import { CordataSearchWorksResponse } from "@biblioteksentralen/bmdb-search-client";
import WorksList from "./WorksList";

type Props = {
  works: CordataSearchWorksResponse["results"];
  endOfResults: boolean;
  isValidating: boolean;
  paginate: () => void;
};

const SearchResultsWork = ({ works, endOfResults, isValidating, paginate }: Props) => {
  const { areSearchResultsLoading: isLoading } = useSearchContext();

  if (isLoading)
    return (
      <Center>
        <Spinner size="xl" />
      </Center>
    );

  return (
    <Box as="section" marginBottom="2rem">
      {!isLoading && (
        <WorksList works={works} endOfResults={endOfResults} isValidating={isValidating} paginate={paginate} />
      )}
    </Box>
  );
};

export default SearchResultsWork;
